module.exports = __webpack_public_path__ + "static/media/myProfile.5663f198.png";